import { EUnitOfMeasure } from '../shared/enum';
import { TMaterial, TParametersForTheDesignOfBedProtection, TPhysicalData, TRevetmentCharacteristicsForPilarczykFormula } from '../shared/iProject';
import { EUnitOfMeasureImperialLabel, EUnitOfMeasureMetricLabel } from './enum';

//RevetmentCharacteristicsForPilarczykFormula
export const depthParameterKh: TParametersForTheDesignOfBedProtection = 'depthParameterKh';
export const slopeParameter: TParametersForTheDesignOfBedProtection = 'slopeParameter';
export const turbolenceParameterKt: TParametersForTheDesignOfBedProtection = 'turbolenceParameterKt';
export const stabilityParameter: TParametersForTheDesignOfBedProtection = 'stabilityParameter';

export const parametersForTheDesignOfBedProtectionPhysicalData = {
    [depthParameterKh]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [slopeParameter]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [turbolenceParameterKt]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [stabilityParameter]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
};

//RevetmentCharacteristicsForPilarczykFormula
export const widthOfTheProtectionW: TRevetmentCharacteristicsForPilarczykFormula = 'widthOfTheProtectionW';

export const revetmentCharacteristicsForPilarczykFormulaPhysicalData = {
    [widthOfTheProtectionW]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.feet,
        },
    },
};

//PhysicalData
export const thickness: TPhysicalData = 'thickness';
export const doubleMaterialThickness: TPhysicalData = 'doubleMaterialThickness';
export const thicknessIn: TPhysicalData = 'thicknessIn';
export const rockD50: TPhysicalData = 'rockD50';
export const rockD50in: TPhysicalData = 'rockD50in';
export const relativeDensity: TPhysicalData = 'relativeDensity';
export const shieldsParameter: TPhysicalData = 'shieldsParameter';
export const equivalentThickness: TPhysicalData = 'equivalentThickness';
export const equivalentThicknessIn: TPhysicalData = 'equivalentThicknessIn';
export const geotextileFilter: TMaterial = 'geotextileFilter';
export const xties: TMaterial = 'xties';

export const physicalData = {
    [thickness]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.inch,
        },
    },
    [doubleMaterialThickness]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.inch,
        },
    },
    [rockD50]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.inch,
        },
    },
    [equivalentThickness]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.inch,
        },
    },
    [shieldsParameter]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [relativeDensity]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [geotextileFilter]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [xties]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
};
